var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrezor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 49,
    viewBox: "0 0 50 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3551_9508)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 4,
    fill: "#204837"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5479 18.4694C30.5479 15.5954 28.0534 13.2094 25.0169 13.2094C21.9803 13.2094 19.4858 15.5954 19.4858 18.4694V20.1505H17.2083V32.2431L25.0169 35.8762L32.8255 32.2431V20.205H30.5479V18.4694ZM22.3053 18.4694C22.3053 17.1139 23.4983 16.0294 25.0169 16.0294C26.5354 16.0294 27.7284 17.1139 27.7284 18.4694V20.1505H22.3053V18.4694ZM29.6804 30.2911L25.0169 32.4601L20.3533 30.2911V23.0245H29.6804V30.2911Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3551_9508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 50,
    fill: "white",
    transform: "translate(-1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrezor);
export default __webpack_public_path__ + "static/media/trezor.5b7fa5316c4f1faf591880c277d047b8.svg";
export { ForwardRef as ReactComponent };